$(document).ready(function () {
  $(".readonly").on("keydown paste focus mousedown", function (e) {
    if (e.keyCode != 9)
      // ignore tab
      e.preventDefault();
  });
  $(document).find("#initials_number").attr("name", "");
  $(document).find("#initials_number_color").attr("name", "");
  $(document).find("#initials_name").attr("name", "");
  $(document).find("#initials_name_color").attr("name", "");
  $(document).find("#front_engraving_text").attr("name", "");
  $(document).find("#back_engraving_text").attr("name", "");

  //video section play btn
  $(".vdo_play svg").click(function () {
    $("#youtube_play")[0].contentWindow.postMessage(
      '{"event":"command","func":"' + "playVideo" + '","args":""}',
      "*"
    );
    $(".vdo_pause").show();
    $(".vdo_play").hide();
  });
  $(".vdo_pause svg").click(function () {
    $(".vdo_pause").hide();
    $(".vdo_play").show();
    $("#youtube_play")[0].contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });

  //homepage fullwidth slider
  if ($(document).find(".full_width_slider").length) {
    var swiper = new Swiper(".full_width_slider", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".itg_homebanner_next",
        prevEl: ".itg_homebanner_prev",
      },
    });
  }

  //collection list slider
  if ($(document).find(".itg_collectionlist_slider").length) {
    var swiper = new Swiper(".itg_collectionlist_slider", {
      slidesPerView: 1,
      autoplay: true,
      loop: true,
      centeredSlides: false,
      grabCursor: true,
      draggable: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }

  //bundle collection slider
  //collection list slider
  if ($(document).find(".itg_bundle_collection").length) {
    var swiper = new Swiper(".itg_bundle_collection", {
      slidesPerView: 1,
      loop: true,
      autoplay: true,
      grabCursor: true,
      draggable: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 2,
        },
      },
    });
  }

  //featured collection section slider
  // if ($(document).find(".itg_featured_collection_slider").length) {
  //   var swiper = new Swiper(".itg_featured_collection_slider", {
  //     loop: true,
  //     spaceBetween: 30,
  //     grabCursor: true,
  //     draggable: true,
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //     scrollbar: {
  //       el: ".swiper-scrollbar",
  //     },
  //     breakpoints: {
  //       0: {
  //         slidesPerView: 1,
  //       },
  //       480: {
  //         slidesPerView: 1,
  //       },
  //       768: {
  //         slidesPerView: 3,
  //       },
  //       1024: {
  //         slidesPerView: 4,
  //       },
  //     },
  //   });
  // }

  //upsell product slider on cart drawer
  // if ($(document).find(".itg_cart_upsell_slider").length && window.innerWidth < '769' ) {
  //   var swiper = new Swiper(".itg_cart_upsell_slider", {
  //     navigation: {
  //       nextEl: ".swiper-button-next",
  //       prevEl: ".swiper-button-prev",
  //     },
  //   });
  // }

  //faq ptab section slider
  if ($(document).find(".itg_faq_slider").length) {
    var swiper = new Swiper(".itg_faq_slider", {
      loop: false,
      spaceBetween: 0,
      autoplay: false,
      grabCursor: true,
      draggable: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          autoplay: false,
        },
        480: {
          slidesPerView: 1,
          autoplay: false,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

  //highlight banner slider
  if ($(document).find(".itg_bnnr_slider").length) {
    var swiper = new Swiper(".itg_bnnr_slider", {
      loop: false,
      spaceBetween: 0,
      grabCursor: true,
      draggable: true,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        480: {
          slidesPerView: 2,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        768: {
          slidesPerView: 2,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        990: {
          slidesPerView: 3,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        1024: {
          slidesPerView: 4,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            disabledClass: "disabled_swiper_button",
          },
        },
      },
    });
  }

  //related product  slider
  if ($(document).find(".itg_related_slider").length) {
    var swiper = new Swiper(".itg_related_slider", {
      loop: true,
      spaceBetween: 30,
      grabCursor: true,
      draggable: true,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }

  //text section slider
  if ($(document).find(".swiper--top").length) {
    let SwiperTop = new Swiper(".swiper--top", {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 2000,
      autoplay: {
        delay: 0,
      },
      loop: true,
      grabCursor: true,
      draggable: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 9,
        },
      },
    });
  }

  //announcement bar section slider
  if ($(document).find(".itg_announcement").length) {
    var announcement = new Swiper(".itg_announcement", {
      //spaceBetween: 30,
      // centeredSlides: true,
      slidesPerView: 1,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    });
  }

  $(document).on(
    "click",
    "ul.list-menu li .mega-menu .header__menu-item",
    function () {
      $(this)
        .parents(".header__inline-menu")
        .find(".mega-menu__content")
        .addClass("main-top");
      // $(this)
      //   .parents(".mega-menu")
      //   .find(".mega-menu__list .mega_menus_itg:first")
      //   .addClass("li_hover");
      $(this)
        .parents(".mega-menu")
        .find(".mega-menu__list .mega_menus_itg:first .mega_submenus")
        .addClass("bg_color");
      $(this)
        .parents(".mega-menu")
        .find(
          ".mega-menu__list .mega_menus_itg:first .mega_submenus .grandchildlink_link"
        )
        .addClass("show");
      $(this)
        .parents(".mega-menu")
        .find(".mega-menu__list .mega_menus_itg .menus_coll_img")
        .addClass("coll_show");
      $(this)
        .parents(".mega-menu")
        .find(
          ".mega-menu__list .mega_menus_itg .menus_coll_img.coll_show .menu_collection_product .mega_product:first"
        )
        .show();
      // $(this)
      //   .parents(".header__inline-menu")
      //   .find(".mega-menu__content .grandchildlink_link li:first ")
      //   .addClass("main_li_hover");
    }
  );

  // $("ul.mega-menu__list li").mouseover(function () {
  //   $(".mega_menus_itg").removeClass("li_hover");
  //   $(this)
  //     .parents(".mega-menu")
  //     .find(".mega-menu__list .mega_menus_itg:first")
  //     .removeClass("li_hover");
  //   $(this).parents(".mega_menus_itg").addClass("li_hover");
  //   $(".grandchildlink_link").removeClass("show");
  //   $(this)
  //     .parents(".mega_menus_itg")
  //     .find(".grandchildlink_link")
  //     .addClass("show");
  //   $(this).parents(".mega_menus_itg").find(".grandchildlink_link").slideDown();
  //   $(".mega_submenus").addClass("bg_color");
  //   $(".menus_coll_img").removeClass("coll_show");
  //   //$(this).parents(".mega_menus_itg").find( ".mega_product" ).first().addClass( "active_nav" );
  //   $(this).parents(".mega-menu__content").addClass("main-height");
  //   $(this)
  //     .parents(".header__inline-menu")
  //     .find(".mega-menu__content")
  //     .removeClass("main-top");
  // });

  $(".grandchildlink_link li").mouseover(function () {
    $(".mega_product").removeClass("active_nav");
    $(".menus_coll_img").removeClass("coll_show");
    $(this)
      .parents(".mega_menus_itg ")
      .find(".menus_coll_img")
      .addClass("coll_show");
    var link = $(this).find(".mega-menu__link").attr("href");
    var image = $(this).attr("data-image");
    $(".collection_images a").attr("href", link);
    //$(".menus_coll_img .motion-reduce").attr("src", image);
    var link_data = $(this).attr("data-title");
    var product_title = $(this).attr("data-products");
    $(".mega_product").each(function () {
      var product_img = $(this).attr("data-product");
      var product_img2 = $(this).attr("data-product");
      if (link_data == product_img) {
        $(this).css("display", "flex");
      } else if (product_title == product_img2) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  $("ul.mega_menus_itg>li").mouseover(function () {
    var varActive = $(this)
      .closest(".mega_menus_itg")
      .find(".mega_menus_alls>ul>li:first")
      .attr("data-title");
    $(this)
      .closest(".mega_menus_itg")
      .find(".menus_coll_img")
      .addClass("coll_show");
    $(this)
      .closest(".mega_menus_itg")
      .find('.menu_collection_product [data-product="' + varActive + '"]')
      .css("display", "flex");
    $(this)
      .parents(".header__inline-menu")
      .find(".mega-menu__content")
      .addClass("main-top");
  });

  if ($(document).find(".itg-engraving-button").length) {
    $(document).on("click", ".itg-engraving-button", function (event) {
      if ($(document).find('[name="properties[Product Relation]"]').length) {
        var number = 10000 + Math.floor(Math.random() * 10000);
        $(document).find('[name="properties[Product Relation]"]').val(number);
      }
      var closeform = $(this).closest(".product__form");
      var checkengrave = closeform
        .find(".engraving-selection input:checked")
        .data("value");
      var engraveId = closeform
        .find(".engraving-selection input:checked")
        .data("id");
      var engraveProductId = closeform
        .find('[name="properties[Product Relation]"]')
        .val();
      var engraveText = closeform.find(".engravingtext").val();
      var quantity = closeform.find('[name="quantity"]').val();
      event.preventDefault();
      if (checkengrave == true) {
        if (!$.trim(engraveText).length) {
          closeform.find(".engravingtext-box").addClass("error");
        } else {
          closeform.find(".engravingtext-box").removeClass("error");
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: quantity,
              id: engraveId,
              properties: { "Product Relation": engraveProductId },
            },
            dataType: "json",
            success: function (data) {
              closeform.find(".hidden-add-btn").trigger("click");
            },
            error: function () {
              location.reload();
            },
          });
        }
      } else {
        $(document).find(".engravingtext").val("");
        closeform.find(".hidden-add-btn").trigger("click");
      }
    });
  }

  //Engraving  option click
  $(document).find(".ctm-swatch").find("input.first").prop("checked", true);
  $(document).on("change", ".engraving-selection input:radio", function () {
    var dataValue = $(this).data("value");
    if (dataValue) {
      $(document)
        .find("#front_engraving_text")
        .attr("name", "properties[Engraving Text]");
      $(document)
        .find("#back_engraving_text")
        .attr("name", "properties[Back Text]");
      $(document)
        .find(".engraving_hidden")
        .find("input.first")
        .prop("checked", true);
      $(".engraving_hidden").slideDown();
    } else {
      $(".engraving_hidden").slideUp();
      $(document)
        .find(".engraving_hidden")
        .find("input")
        .prop("checked", false);
      $(document).find(".engravingtext").val("");
      $(document).find("#front_engraving_text").attr("name", "");
      $(document).find("#back_engraving_text").attr("name", "");
    }
  });

  //product page tab
  $("#tabs-nav li:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $("#tabs-nav li").click(function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  //all variant option show
  $(document).on("click", ".itg_more_option", function () {
    $(".itg_all_variant_show").toggleClass("open");
    $(this).toggleClass("less");
    if ($(this).hasClass("less")) {
      $(this).text("less");
    } else {
      $(this).text("more");
    }
  });

  //select lanuage in input filed

  $(".itg_lan").click(function () {
    var input_value = $(this).find("input").attr("id");
    $('input[name="properties[Engraving Text]"]')
      .removeClass("oldenglish")
      .removeClass("prohibition")
      .removeClass("prohibition1")
      .removeClass("script")
      .removeClass("arial")
      .addClass(input_value);
    //$('.engravingtext').removeClass(input_value);
    //$('.engravingtext').addClass(input_value);
  });

  $(".itg_lan").click(function () {
    var input_value = $(this).find("input").attr("id");
    $('input[name="properties[Back Text]"]')
      .removeClass("oldenglish")
      .removeClass("prohibition")
      .removeClass("prohibition1")
      .removeClass("script")
      .removeClass("arial")
      .addClass(input_value);
  });

  // chain type name
  $(document).on("click", ".itg_chain_type", function () {
    var chain_type = $(this).find("input").val();
    var chain_price = $(this).find("input").attr("data-price");
    $(".itg_chain_heading span").text(chain_type + " + " + chain_price);
  });

  //product page custom add to cart
  $(document).on("click", ".necklace_product label", function () {
    $(".necklace_product label").removeClass("necklace_product_active");
    $(this).addClass("necklace_product_active");
  });

  $(document).on("click", ".cus_cart_remove span", function () {
    $(document).find(".loader-bg").css("display", "flex");
    var randomNumber = $(this).attr("data-number");
    console.log(this);
    var itemid = $(this).attr("data-item");
    Shopify.queue = [];
    $(document)
      .find(".itg_custom_drawer")
      .each(function () {
        var engravId = $(this).attr("data-randnumber");
        if (engravId == randomNumber) {
          var thisKey = $(this).attr("data-key");
          Shopify.queue.push({
            variantId: thisKey,
            variantqty: 0,
          });
        }
      });
    let updates = {};
    Shopify.queue.forEach(function (item) {
      updates[item.variantId] = item.variantqty;
    });
    console.log(updates);

    // Make AJAX call to update cart
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle success response here
        // Reload the page
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    // Shopify.moveAlong = function () {
    //   if (Shopify.queue.length) {
    //     var request = Shopify.queue.shift();
    //     var varid = request.variantId;
    //     var varqty = request.variantqty;
    //     console.log(varid);
    //     $.ajax({
    //       method: "POST",
    //       url: "/cart/change.js",
    //       data: { id: varid, quantity: 0 },
    //       dataType: "json",
    //       success: function (res) {
    //         Shopify.moveAlong();
    //       },
    //       error: function (data) {
    //         Shopify.moveAlong();
    //       },
    //     });
    //   } else {
    //     // window.location.reload();
    //   }
    // };
    // Shopify.moveAlong();
  });

  $(document).on("click", "#itg_custom_btn", function () {
    $(document).find("#itg_random_number").val("");
    var necklace_active_product = $(document)
      .find(".necklace_product label")
      .hasClass("necklace_product_active");
    console.log(necklace_active_product);
    var envqty = $(this)
      .closest(".product-form__buttons")
      .find(".quantity__input")
      .val();
    if (necklace_active_product == false) {
      alert("Please select option");
      return false;
    } else {
      $(document).find("#itg_random_number").val("");
      $(document).find("#itg_random_number").attr("name", "properties[Rno]");
      var engraving_id = $(document)
        .find("#engraving_location_data .engraving_box input:checked")
        .attr("data-engrav");
      var chainLen = $(
        ".itg_custom_options .itg_chain_lenght input:checked"
      ).val();
      var chainType = $(
        ".itg_custom_options .itg_chain_type input:checked"
      ).val();
      var compair_text = chainLen + " / " + chainType;
      var additionalProd = $(
        '.itg_product_variant_select option[data-title="' + compair_text + '"]'
      ).attr("value");
      var randomnumber = 1 + Math.floor(Math.random() * 1000);
      $(document).find("#itg_random_number").val(randomnumber);

      var ths_location = $(document)
        .find(
          '#engraving_location_data input[name="properties[Engraving Location]"]:checked'
        )
        .attr("id");

      Shopify.queue = [];
      if (engraving_id != undefined) {
        var toPushItem = additionalProd;
        var toPushItem1 = engraving_id;
        Shopify.queue.push({
          variantId: toPushItem,
        });
        Shopify.queue.push({
          variantId: toPushItem1,
        });
      } else {
        if (additionalProd != undefined) {
          Shopify.queue.push({
            variantId: additionalProd,
          });
        }
      }

      if (
        document
          .querySelector(".custom-packaging input:checked")
          .getAttribute("data-value")
      ) {
        Shopify.queue.push({
          variantId: document
            .querySelector(".custom-packaging input:checked")
            .getAttribute("data-value"),
        });
      }

      if (engraving_id == undefined) {
        $(document).find(".loader-bg").css("display", "flex");
        Shopify.moveAlong = function () {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var varid = request.variantId;
            var arrdata = {};
            arrdata["Rno"] = randomnumber;
            $.ajax({
              method: "POST",
              url: "/cart/add.js",
              data: {
                id: varid,
                quantity: envqty,
                properties: arrdata,
              },
              dataType: "json",
              success: function (res) {
                Shopify.moveAlong();
              },
              error: function (data) {
                Shopify.moveAlong();
              },
            });
          } else {
            $(document).find(".itg_main_product_btn").trigger("click");
          }
        };
        Shopify.moveAlong();
      } else {
        if (ths_location == "front" || ths_location == "back") {
          var front_engraving_text = $(document)
            .find("#front_engraving_text")
            .val();
          if (front_engraving_text == "") {
            $("#front_engraving_text").focus();
            $("#front_engraving_text").addClass("focused");
            return false;
          } else {
            $("#front_engraving_text").removeClass("focused");
            $(document).find(".loader-bg").css("display", "flex");
            Shopify.moveAlong = function () {
              if (Shopify.queue.length) {
                var request = Shopify.queue.shift();
                var varid = request.variantId;
                var arrdata = {};
                arrdata["Rno"] = randomnumber;
                $.ajax({
                  method: "POST",
                  url: "/cart/add.js",
                  data: {
                    id: varid,
                    quantity: envqty,
                    properties: arrdata,
                  },
                  dataType: "json",
                  success: function (res) {
                    Shopify.moveAlong();
                  },
                  error: function (data) {
                    Shopify.moveAlong();
                  },
                });
              } else {
                $(document).find(".itg_main_product_btn").trigger("click");
              }
            };
            Shopify.moveAlong();
          }
        } else {
          var front_engraving_text = $(document)
            .find("#front_engraving_text")
            .val();
          var back_engraving_text = $(document)
            .find("#back_engraving_text")
            .val();
          if (front_engraving_text == "") {
            $("#front_engraving_text").focus();
            $("#front_engraving_text").addClass("focused");
            return false;
          } else if (back_engraving_text == "") {
            $("#back_engraving_text").focus();
            $("#back_engraving_text").addClass("focused");
            return false;
          } else {
            $("#front_engraving_text").removeClass("focused");
            $("#back_engraving_text").removeClass("focused");

            $(document).find(".loader-bg").css("display", "flex");
            Shopify.moveAlong = function () {
              if (Shopify.queue.length) {
                var request = Shopify.queue.shift();
                var varid = request.variantId;
                var arrdata = {};
                arrdata["Rno"] = randomnumber;
                $.ajax({
                  method: "POST",
                  url: "/cart/add.js",
                  data: {
                    id: varid,
                    quantity: envqty,
                    properties: arrdata,
                  },
                  dataType: "json",
                  success: function (res) {
                    Shopify.moveAlong();
                  },
                  error: function (data) {
                    Shopify.moveAlong();
                  },
                });
              } else {
                $(document).find(".itg_main_product_btn").trigger("click");
              }
            };
            Shopify.moveAlong();
          }
        }
      }
    }
  });

  //variant zoom effect
  $(".swatch_hover_main").hide();
  var windowsize = $(window).width();
  if (windowsize > 767) {
    $(".ctm_chain_type label").mouseenter(function () {
      $(".swatch_hover_main").show();
      var data_id = $(this).find("img").attr("src");
      var data_value = $(this).attr("data-option-val");
      $(".swatch_hover_main img").attr("src", data_id);
      $(".swatch_hover_main span.variant-label__value").text(data_value);
    });
    $(".ctm_chain_type label").mouseleave(function () {
      $(".swatch_hover_main").hide();
    });
  } else {
    $(".itg_chain_type_product .itg_chain_type label").click(function () {
      $(".swatch_hover_main").show();
      var data_id = $(this).find("img").attr("src");
      var data_value = $(this).attr("data-option-val");
      $(".swatch_hover_main img").attr("src", data_id);
      $(".swatch_hover_main span.variant-label__value").text(data_value);
    });
    $(".itg_hover_img_close").click(function () {
      $(".swatch_hover_main").hide();
    });
  }

  //product image zoom
  $(".img_producto_container").on("mouseover", function () {
    $(this)
      .find("img")
      .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
  });
  $(".img_producto_container").on("mouseover", function () {
    $(this)
      .find("img")
      .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
  });
  $(".img_producto_container").on("mouseout", function () {
    $(this).find("img").css({ transform: "scale(1)" });
  });
  $(".img_producto_container").on("mousemove", function (e) {
    $(this)
      .find("img")
      .css({
        "transform-origin":
          ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
          "% " +
          ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
          "%",
      });
  });

  //click to both engreving show js
  $(document).on("click", ".engraving_box #both", function () {
    $(document)
      .find("#back_engraving_text")
      .attr("name", "properties[Back Text]");
    $(this)
      .parents(".engraving_hidden")
      .find(".engraving_location_twoinput")
      .addClass("engraving_twoshow");
    $(this)
      .parents(".engraving_hidden")
      .find("#engraving_text")
      .removeClass("back_textinput");
    $(this)
      .parents(".engraving_hidden")
      .find('.engraving_location_twoinput input[type="text"]')
      .val("");
    $(this)
      .parents(".engraving_hidden")
      .find('#engraving_text input[type="text"]')
      .val("");
  });

  $(document).on("click", ".engraving_box #front", function () {
    $(document).find("#back_engraving_text").attr("name", "");
    $(this)
      .parents(".engraving_hidden")
      .find(".engraving_location_twoinput")
      .addClass("engraving_twoshow");
    $(this)
      .parents(".engraving_hidden")
      .find("#engraving_text")
      .addClass("back_textinput");
    $(this)
      .parents(".engraving_hidden")
      .find('.engraving_location_twoinput input[type="text"]')
      .val("");
    $(this)
      .parents(".engraving_hidden")
      .find('#engraving_text input[type="text"]')
      .val("");
  });

  $(document).on("click", ".engraving_box #back", function () {
    $(document).find("#back_engraving_text").attr("name", "");
    $(this)
      .parents(".engraving_hidden")
      .find(".engraving_location_twoinput")
      .addClass("engraving_twoshow");
    $(this)
      .parents(".engraving_hidden")
      .find("#engraving_text")
      .addClass("back_textinput");
    $(this)
      .parents(".engraving_hidden")
      .find('.engraving_location_twoinput input[type="text"]')
      .val("");
    $(this)
      .parents(".engraving_hidden")
      .find('#engraving_text input[type="text"]')
      .val("");
  });

  //cart drawer this code for progress bar
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var target = 50;
      var cartTotal = cart.total_price;
      var final_price = cartTotal / 100;
      var pro = (final_price / target) * 100 + "%";
      var final_gift = (target - final_price).toFixed(2);
      if (cart.item_count <= 0) {
        $(".itg_you_may").hide();
        $(".itg_progress_main").hide();
      }
      if (final_price < target) {
        $(".itg_progress_main .progress_text").html(
          'Only <span class="text_pro"> $' +
            final_gift +
            "</span> TO GO TO UNLOCK FREE US SHIPPING!"
        );
        $(".itg_progress_main .current_progress").css("width", pro);
      } else {
        $(".itg_progress_main .current_progress").css("width", "100%");
        $(".itg_progress_main .progress_text").html(
          "CONGRATS! YOU'VE UNLOCKED FREE US SHIPPING!"
        );
        $(".itg_you_may").show();
      }
    },
  });

  window.updateShippingProgressBar = function () {
    $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      success: function (cart) {
        var target = 50;
        var cartTotal = cart.total_price;
        var final_price = cartTotal / 100;
        var pro = (final_price / target) * 100 + "%";
        var final_gift = (target - final_price).toFixed(2);

        if (cart.item_count <= 0) {
          $(".itg_progress_main").hide();
          $(".itg_you_may").hide();
        }
        if (final_price < target) {
          console.log("heloo");
          $(".itg_progress_main .progress_text").html(
            'Only <span class="text_pro"> $' +
              final_gift +
              "</span> TO GO TO UNLOCK FREE US SHIPPING!"
          );
          $(".itg_progress_main .current_progress").css("width", pro);
        } else {
          $(".itg_progress_main .current_progress").css("width", "100%");
          $(".itg_progress_main .progress_text").html(
            "CONGRATS! YOU'VE UNLOCKED FREE US SHIPPING!"
          );
          $(".itg_you_may").show();
        }
      },
    });
  };

  $(document).on("click", ".quantity__button, cart-remove-button", function () {
    setTimeout(function () {
      window.updateShippingProgressBar();
    }, 1500);
  });

  //cart drawer upsell add button functionality
  $(document).on("click", ".wrist_add", function () {
    $(this).parents(".mystery-meta").find(".mystery-sizes").show();
    $(this).parents(".mystery-meta").find(".mystery-hide").hide();
  });

  // cart drawer free gift progress bar
  $(".itg_gift_cart_btn").hide();
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cart) {
      var target = 100;
      var cartTotal = cart.total_price;
      var final_price = cartTotal / 100;
      var pro = (final_price / target) * 100 + "%";
      var final_gift = (target - final_price).toFixed(2);
      if (cart.item_count <= 0) {
        $(".itg_progress_main_gift").hide();
      }
      if (final_price < target) {
        $(".itg_progress_main_gift .progress_text_gift").html(
          'ADD <span class="text_pro"> $' +
            final_gift +
            "</span>  MORE TO QUALITY FOR A FREE GIFT!"
        );
        $(".itg_progress_main_gift .current_progress_gift").css("width", pro);
        $(".itg_gift_btn .itg_free_gift_btn").attr("disabled", true);
        $(".itg_gift_btn .itg_free_gift_btn").text("locked");
        $(".itg_gift_btn .itg_free_gift_btn").css("display", "flex");
        $(".itg_gift_cart_btn").css("display", "none");
      } else {
        $(".itg_progress_main_gift .current_progress_gift").css(
          "width",
          "100%"
        );
        $(".itg_progress_main_gift .progress_text_gift").html(
          "CONGRATS! YOU'VE EARNED A FREE GIFT!"
        );
        $(".itg_gift_btn .itg_free_gift_btn").attr("disabled", false);
        $(".itg_free_gift_btn").hide();
        $(".itg_gift_cart_btn").css("display", "flex");
      }
    },
  });

  $(document).on("click", ".quantity__button,cart-remove-button", function () {
    setTimeout(function () {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (cart) {
          var target = 100;
          var cartTotal = cart.total_price;
          var final_price = cartTotal / 100;
          var pro = (final_price / target) * 100 + "%";
          var final_gift = (target - final_price).toFixed(2);
          if (cart.item_count <= 0) {
            $(".itg_progress_main_gift").hide();
          }
          if (final_price < target) {
            $(".itg_progress_main_gift .progress_text_gift").html(
              'ADD <span class="text_pro"> $' +
                final_gift +
                "</span> MORE TO QUALITY FOR A FREE GIFT!"
            );
            $(".itg_progress_main_gift .current_progress_gift").css(
              "width",
              pro
            );
            $(".itg_gift_btn .itg_free_gift_btn").attr("disabled", true);
            $(".itg_gift_btn .itg_free_gift_btn").text("locked");
            $(".itg_gift_btn .itg_free_gift_btn").css("display", "block");
            $(".itg_gift_cart_btn").css("display", "none");
          } else {
            $(".itg_progress_main_gift .current_progress_gift").css(
              "width",
              "100%"
            );
            $(".itg_progress_main_gift .progress_text_gift").html(
              " CONGRATS! YOU'VE EARNED A FREE GIFT! "
            );
            $(".itg_gift_btn .itg_free_gift_btn").attr("disabled", false);
            $(".itg_free_gift_btn").hide();
            $(".itg_gift_cart_btn").css("display", "flex");
            gift_addons();
          }

          function gift_addons() {
            var prodcut_handle = "gift-product";
            var newurl =
              window.location.protocol +
              "//" +
              window.location.host +
              "/products/" +
              prodcut_handle;
            $.ajax({
              url: newurl,
              type: "GET",
              dataType: "html",
              success: function (res) {
                $(document).find(".itg_gift_btn").html("");
                var product_data = $(res).find(".itg_main_form").html();
                $(document).find(".itg_gift_btn").html(product_data);
              },
            });
          }
        },
      });
    }, 1500);
  });

  $(document).on("click", ".product-name", function () {
    $("html,body").animate(
      {
        scrollTop: $(".itg_product_tab_wrapper").offset().top,
      },
      "slow"
    );
    $('#tabs-nav li a[href="#tab2"]').trigger("click");
  });

  //wristband bundle product
  $(document).on("click", ".itg_bundle_pro", function () {
    $("html,body").animate(
      {
        scrollTop: $(
          "#wristbandapp, #headbandapp, #armsleeveapp, #siliconeringapp, #shakercupapp"
        ).offset().top,
      },
      "slow"
    );
  });

  //custom collection filter
  function historly_filter() {
    var collection_url = $(document)
      .find(".itg_filter_maindiv")
      .attr("data-url");
    var tag_list = "/";
    $(document)
      .find(".main-filter.active_box")
      .find("input")
      .each(function (index) {
        if (index == 0) {
          tag_list += $(this).val();
        } else {
          tag_list += "+" + $(this).val();
        }
      });
    collection_url += tag_list;
    $.ajax({
      type: "GET",
      url: collection_url,
      beforeSend: function () {},
      success: function (data) {
        var paginationHtml = $(data).find("#Huratips-Pagination").html();
        var collectionGrid = $(data).find("#product-grid").html();
        var hidden_url = $(data).find("#itg_appended_data").val();
        $(document).find("#product-grid").html(collectionGrid);
        $(document).find("#itg_appended_data").val(collection_url);
        if ($(data).find("#Huratips-Pagination").length) {
          $(document).find("#Huratips-Pagination").html(paginationHtml);
        } else {
          $(document).find("#Huratips-Pagination").html("");
        }

        var obj = { Title: "ChangeUrl", Url: collection_url };
        history.pushState(obj, obj.Title, obj.Url);
      },
      dataType: "html",
    });
  }
  //collection filter clear filter option
  $('.filter_item li input[type="checkbox"]').change(function () {
    var active_filter = $(
      '.filter_item li input[type="checkbox"]:checked'
    ).length;
    if (active_filter >= 1) {
      $(".itg_filter_clear_btn").css("display", "inline-block");
    } else {
      $(".itg_filter_clear_btn").css("display", "none");
    }
  });
  var active_filter = $(
    '.filter_item li input[type="checkbox"]:checked'
  ).length;
  if (active_filter >= 1) {
    $(".itg_filter_clear_btn").css("display", "inline-block");
  } else {
    $(".itg_filter_clear_btn").css("display", "none");
  }

  $(document).on("change", ".filter_item_main li label", function () {
    if ($(this).closest(".main-filter").hasClass("active_box")) {
      $(this).closest(".main-filter").removeClass("active_box");
    } else {
      $(this).closest(".main-filter").addClass("active_box");
    }
    historly_filter();
  });

  $(document).on("click", ".filter_item", function (e) {
    e.stopPropagation();
    if ($(this).hasClass("itg_filter_option_open")) {
      if (e.target.classList.contains("accordian")) {
      } else {
        $(this).removeClass("itg_filter_option_open");
      }
    } else {
      $(".filter_item").removeClass("itg_filter_option_open");
      $(this).addClass("itg_filter_option_open");
    }
  });

  $(document).on("change", "body", function () {
    $(".filter_item").removeClass("itg_filter_option_open");
  });
  var windowsize = $(window).width();
  if (windowsize < 767) {
    $(".itg_mobile_filter").click(function (e) {
      e.stopPropagation();
      $(".filter_main")
        .css("right", "0")
        .css("opacity", "1")
        .css("visibility", "visible");
      console.log("cart closed 1");
    });
    $(".custom_filter_closed").click(function (e) {
      e.stopPropagation();
      $(".filter_main")
        .css("right", "-300px")
        .css("opacity", "0")
        .css("visibility", "hidden");
      console.log("cart closed 2");
    });
    // $("body").click(function () {
    //   $(".filter_main")
    //     .css("right", "-300px")
    //     .css("opacity", "0")
    //     .css("visibility", "hidden");
    //   console.log("cart closed 3")
    // });
  }

  //cart drawer upcell variant select and add to cart
  $(document).on("change", ".itg_variant_select", function () {
    var var_id = $(this).find("option:selected").attr("data-variant-id");
    console.log("var_id:-" + var_id);
    $(this)
      .closest(".mini-cart__mystery")
      .find(".product-variant-id")
      .val(var_id);
  });

  //headband form page
  $(document).on("click", ".itg_select_headband", function () {
    $(".itg_allproduct_list").toggleClass("open");
  });

  // $(document).on("change", "#itg_img_upload", function () {
  //   if ($(this).val() != "") {
  //     $("#getfile").val("");
  //     var form_data = new FormData();
  //     var file_data = $("#itg_img_upload").prop("files")[0];
  //     form_data.append("image", file_data);
  //     $(document).find(".loader-bg").css("display", "flex");
  //     $.ajax({
  //       type: "POST",
  //       url: "https://dev.shopifyexperthelp.com/app/project_custom_code/elite/file_upload.php",
  //       data: form_data,
  //       contentType: false,
  //       cache: false,
  //       processData: false,
  //       success: function (response) {
  //         $("#getfile").val(response);
  //
  //       },
  //     });
  //   }
  // });

  $(document).on("click", ".itg_allproduct_list ul li", function () {
    var pro_title = $(this).attr("data-title");
    $(document).find("#productName").val("");
    $(document).find("#getpurl").val("");
    $(document).find("#getfile").val();
    var purl = $(this).attr("data-url");
    var pname = $(this).attr("data-title");
    $(document).find("#productName").val(pname);
    $(document).find("#getpurl").val(purl);
    $(this).parents(".itg_allproduct_list").removeClass("open");
    $(".itg_pickheadband_product #getpname").val(pro_title);
  });

  $(document).on("click", "#itg_custom_btn_customize", function () {
    $(document).find("#itg_random_number").val("");
    $(document).find("#itg_random_number").attr("name", "");
    var envqty = $(this)
      .closest(".product-form__buttons")
      .find(".quantity__input")
      .val();
    var get_cus = $(document)
      .find(".customize_container .button[data-selected=true]")
      .attr("data-custom");
    var formid = $(document).find(".itg_main_form form").attr("id");
    var randomnumber = 1 + Math.floor(Math.random() * 1000);

    if (get_cus == "") {
      $(document).find(".customize_btn_trigger").click();
    } else {
      if ($(".itg_char2 ").hasClass("active")) {
        $(".product__form .upgrade_inputs").remove();
        $(document).find('input[name="properties[Name]"]').val("");
        $(document)
          .find('select[name="properties[Text Color]"] option')
          .removeAttr("selected");
        $(document)
          .find('select[name="properties[Text Color]"] option')
          .prop("selected", false);

        $(document)
          .find('input[name="custom_font_name"]')
          .removeAttr("checked");
        $(document)
          .find('input[name="custom_font_name"]')
          .prop("checked", false);

        var textval = $('input[name="properties[Initials/number]"]').val();
        var txtcolor = $('select[name="properties[Selected Color]"]')
          .find(":selected")
          .val();
        if (textval == "") {
          $('input[name="properties[Initials/number]"]').focus();
          return false;
        } else if (txtcolor == "") {
          $('select[name="properties[Selected Color]"]').focus();
          return false;
        } else {
          $(document)
            .find("#itg_random_number")
            .attr("name", "properties[Rno]");
          finalfunction();
        }
      }

      if ($(".itg_char10  ").hasClass("active")) {
        $(document).find('input[name="properties[Initials/number]"]').val("");
        $(document)
          .find('select[name="properties[Selected Color]"] option')
          .removeAttr("selected");
        $(document)
          .find('select[name="properties[Selected Color]"] option')
          .prop("selected", false);
        var textval = $('input[name="properties[Name]"]').val();
        var txtcolor = $('select[name="properties[Text Color]"]')
          .find(":selected")
          .val();
        var textfont = $(".itg_engraving_location input:checked").val();
        if (textval == "") {
          $('input[name="properties[Name]"]').focus();
          return false;
        } else if (txtcolor == "") {
          $('select[name="properties[Text Color]"]').focus();
          return false;
        } else if (textfont == undefined) {
          alert("please select font");
          return false;
        } else {
          $(document)
            .find("#itg_random_number")
            .attr("name", "properties[Rno]");
          $(".product__form").append(
            '<input type="hidden" class="upgrade_inputs" name="properties[Font]" value="' +
              $('.itg_lan [name="custom_font_name"]:checked').val() +
              '" />'
          );
          finalfunction();
        }
      }

      function finalfunction() {
        $(document).find(".loader-bg").css("display", "flex");
        $(document).find("#itg_random_number").val(randomnumber);
        Shopify.queue = [];
        Shopify.queue.push({
          variantId: get_cus,
        });
        Shopify.moveAlong = function () {
          if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            var varid = request.variantId;
            var arrdata = {};
            arrdata["Rno"] = randomnumber;
            $.ajax({
              method: "POST",
              url: "/cart/add.js",
              data: {
                id: varid,
                quantity: envqty,
                properties: arrdata,
              },
              dataType: "json",
              success: function (res) {
                Shopify.moveAlong();
              },
              error: function (data) {
                Shopify.moveAlong();
              },
            });
          } else {
            $(document).find(".customize_btn_trigger").click();
          }
        };
        Shopify.moveAlong();
      }
    }
  });

  $(document).on("click", "#engraving_location_data label", function () {
    $(document).find("#chnage_evgprice").val("");
    var thslabel = $(this).attr("data-dec");
    $(document).find("#chnage_evgprice").val(thslabel);
  });

  // $(document).on("click", ".cart-quantity .quantity__button", function (event) {
  //   var dataRelation = $(this)
  //     .closest(".cart-item__quantity")
  //     .find(".quantity__input")
  //     .attr("data-number");
  //   var dataRelationqty = $(this)
  //     .closest(".cart-item__quantity")
  //     .find(".quantity__input")
  //     .val();
  //   console.log(dataRelationqty);

  //   if (dataRelation != "") {
  //     event.preventDefault();
  //     var data = { updates: {} };
  //     $(document)
  //       .find(".extra_product_find")
  //       .each(function () {
  //         var engravId = $(this).attr("data-randnumber");
  //         if (engravId == dataRelation) {
  //           var thisKey = $(this).data("key");
  //           data.updates[thisKey] = dataRelationqty;
  //         }
  //       });
  //     jQuery.ajax({
  //       type: "POST",
  //       url: "/cart/update.js",
  //       data: data,
  //       dataType: "json",
  //       success: function (data) {
  //         console.log("success", data);
  //       },
  //     });
  //   }
  // });

  // function drawerloop() {
  //     $.ajax({
  //         type: 'GET',
  //         url: '/cart.js' ,
  //         dataType: 'json',
  //         success: function(cart){
  // 		     var cartTotal = cart.total_price;
  //            var final_price = (cartTotal/100);
  //            if(final_price < 100){
  //              $(document).find(".drawer_gift_product").click();
  //              clearInterval(interval);
  //            }else{
  //              clearInterval(interval);
  //            }
  //         }
  //     });
  // }
  // var interval = self.setInterval(function(){drawerloop()},1000);

  $("input#initials_number").on("keyup change", function (e) {
    var maxLimit = 2;
    var thsnumber = $.trim($(this).val());
    if (thsnumber != "") {
      var $this = $(this);
      var val = $this.val();
      var valLength = val.length;
      if (valLength > maxLimit) {
        $this.val($this.val().substring(0, maxLimit));
      }
    }
  });
  $("input#initials_name").on("keyup change", function (e) {
    var maxLimit = 10;
    var thsnumber = $.trim($(this).val());
    if (thsnumber != "") {
      var $this = $(this);
      var val = $this.val();
      var valLength = val.length;
      if (valLength > maxLimit) {
        $this.val($this.val().substring(0, maxLimit));
      }
    }
  });

  $("input.engravingtext ").on("keyup change", function (e) {
    var maxLimit = $(this).attr("data-max");
    if (maxLimit != "") {
      var maxLimit = $(this).attr("data-max");
    } else {
      var maxLimit = 10;
    }
    var thsnumber = $.trim($(this).val());
    if (thsnumber != "") {
      var $this = $(this);
      var val = $this.val();
      var valLength = val.length;
      if (valLength > maxLimit) {
        $this.val($this.val().substring(0, maxLimit));
      }
    }
  });

  var cartitemfind = localStorage.getItem("cartitem");
  if (cartitemfind == null) {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function (res) {
        localStorage.setItem("cartitem", "all");
      },
      error: function (error) {
        localStorage.setItem("cartitem", "all");
      },
    });
  }
});
// if( window.innerWidth < 641 ) {
//   const swiper = document.querySelector(".itg_collectionlist_slider").swiper;
//   swiper.destroy(false, true);
//   document.querySelector(".swiper").classList.remove("swiper");
//   document.querySelector(".mySwiper").classList.remove("mySwiper");
// }

// Custom js for hover effect on mega menu
const details = document.querySelector(".custom-mega-menu");

// Prevent the default click behavior
// details.addEventListener('click', (event) => {
//   event.preventDefault();
// });

// Add hover behavior
details.addEventListener("mouseenter", () => {
  details.classList.remove("close");
  details.setAttribute("open", "");
});

details.addEventListener("mouseleave", () => {
  // Add the "close" class to trigger the transition
  details.classList.add("close");

  // Wait for the transition to complete before removing the "open" attribute
  const content = details.querySelector(".mega-menu__content");
  setTimeout(() => {
    details.removeAttribute("open");
  }, "300");

  document.querySelector(".mega-menu__content").style.maxHeight = "100%";
  document.querySelector(".mega-menu__content").style.height = "max-content";
});

window.addEventListener("DOMContentLoaded", () => {
  const content = details.querySelector(".mega-menu__content");
  content.style.transform = "translateY(-100%)";
});

// document.querySelectorAll(".mega_menus_itg").forEach((item) => {
//   let openTimeout, closeTimeout;

//   // On mouse enter
//   item.addEventListener("mouseenter", () => {
//     clearTimeout(closeTimeout); // Prevent premature closing

//     // Calculate the height of the submenu content dynamically
//     const content = document.querySelector(".mega-menu__content");
//     const submenu = item.querySelector(".mega_submenus");

//     openTimeout = setTimeout(() => {
//       // Set dynamic height based on content size // Get natural height of content
//       item.setAttribute("open", '')
// content.style.maxHeight = "80vh"; // Set max-height dynamically
//       content.style.height = "80vh";
//       // content.style.transform = "translateY(0)";

//       submenu.classList.add("show"); // Make submenu visible
//     }, 500); // Small delay for smooth effect
//   });

//   // On mouse leave
//   item.addEventListener("mouseleave", () => {
//     clearTimeout(openTimeout); // Prevent opening if quickly hovered out

//     const content = document.querySelector(".mega-menu__content");
//     const submenu = item.querySelector(".mega_submenus");
//     item.removeAttribute("open")
//     closeTimeout = setTimeout(() => {

//       // Reset styles to hide content

//       // content.style.transform = "translateY(-10px)";

//       submenu.classList.remove("show"); // Hide submenu
//     }, 300); // Delay for smoother closing
//   });
// });

document.querySelectorAll(".mega_menus_itg").forEach((item) => {
  let openTimeout, closeTimeout;

  item.addEventListener("mouseenter", () => {
    clearTimeout(closeTimeout);

    // Find the closest parent mega-menu__content
    const parentDetails = item.closest(".custom-mega-menu");
    const submenu = item.querySelector(".mega_submenus");

    if (!parentDetails || !submenu) return;

    document.querySelector(".mega-menu__content").style.maxHeight = "80vh";
    document.querySelector(".mega-menu__content").style.height = "80vh";

    openTimeout = setTimeout(() => {
      // Ensure parent details is open
      parentDetails.setAttribute("open", "");
      item.setAttribute("open", "");
      submenu.classList.add("show");
    }, 100);
  });

  item.addEventListener("mouseleave", () => {
    clearTimeout(openTimeout);

    const submenu = item.querySelector(".mega_submenus");

    if (!submenu) return;
    document.querySelector(".mega-menu__content").style.maxHeight = "100%";
    document.querySelector(".mega-menu__content").style.height = "max-content";
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
      submenu.classList.remove("show");

      // Don't close the parent details on mouseleave
      // Let the parent handle its own closing
    }, 100);
  });
});

// Add handlers for the parent mega-menu as well
document.querySelectorAll(".custom-mega-menu").forEach((menu) => {
  menu.addEventListener("mouseleave", () => {
    // When leaving the entire mega menu, close everything after a delay
    setTimeout(() => {
      menu.removeAttribute("open");
      menu.querySelectorAll(".mega_submenus.show").forEach((submenu) => {
        submenu.classList.remove("show");
      });
      menu.querySelectorAll(".mega_menus_itg[open]").forEach((item) => {
        item.removeAttribute("open");
      });
    }, 300);
  });
});
